export type Language = 'he' | 'en' | 'ar';

export type Direction = 'rtl' | 'ltr';

export interface LanguageConfig {
  code: Language;
  name: string;
  nativeName: string;
  direction: Direction;
  locale: string; // For Shopify checkout
}

export const LANGUAGES: Record<Language, LanguageConfig> = {
  he: {
    code: 'he',
    name: 'Hebrew',
    nativeName: 'עברית',
    direction: 'rtl',
    locale: 'he-IL',
  },
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    direction: 'ltr',
    locale: 'en-US',
  },
  ar: {
    code: 'ar',
    name: 'Arabic',
    nativeName: 'العربية',
    direction: 'rtl',
    locale: 'ar',
  },
};

export const DEFAULT_LANGUAGE: Language = 'he';

// Translation key structure
export interface Translations {
  common: {
    home: string;
    about: string;
    contact: string;
    cart: string;
    wishlist: string;
    profile: string;
    login: string;
    logout: string;
    search: string;
    menu: string;
    close: string;
    back: string;
    next: string;
    previous: string;
    loading: string;
    error: string;
    success: string;
    save: string;
    cancel: string;
    delete: string;
    edit: string;
    add: string;
    remove: string;
    viewAll: string;
    readMore: string;
    learnMore: string;
    giftCard: string;
    customerService: string;
    faq: string;
    sizeGuide: string;
    tradeIn: string;
    trackOrder: string;
    categories: string;
  };
  product: {
    addToCart: string;
    addedToCart: string;
    outOfStock: string;
    inStock: string;
    price: string;
    quantity: string;
    size: string;
    color: string;
    description: string;
    details: string;
    reviews: string;
    relatedProducts: string;
    noProductsFound: string;
    selectOption: string;
    selectSize: string;
    selectColor: string;
  };
  cart: {
    title: string;
    empty: string;
    itemsInCart: string;
    subtotal: string;
    total: string;
    checkout: string;
    continueShopping: string;
    removeItem: string;
    updateQuantity: string;
    proceedToCheckout: string;
  };
  auth: {
    signIn: string;
    signUp: string;
    signOut: string;
    email: string;
    password: string;
    confirmPassword: string;
    forgotPassword: string;
    resetPassword: string;
    createAccount: string;
    alreadyHaveAccount: string;
    dontHaveAccount: string;
    welcomeBack: string;
    personalArea: string;
  };
  footer: {
    about: string;
    shipping: string;
    returns: string;
    privacy: string;
    terms: string;
    accessibility: string;
    cookies: string;
    contactUs: string;
    followUs: string;
    newsletter: string;
    newsletterPlaceholder: string;
    subscribe: string;
    subscribed: string;
    importantLinks: string;
    copyright: string;
  };
  newsletter: {
    title: string;
    subtitle: string;
    placeholder: string;
    button: string;
    success: string;
    error: string;
    consent: string;
  };
  cookies: {
    bannerTitle: string;
    bannerText: string;
    accept: string;
    reject: string;
    customize: string;
    preferencesTitle: string;
    necessary: string;
    necessaryDesc: string;
    analytics: string;
    analyticsDesc: string;
    marketing: string;
    marketingDesc: string;
    savePreferences: string;
  };
  errors: {
    generic: string;
    notFound: string;
    unauthorized: string;
    networkError: string;
    tryAgain: string;
  };
  seo: {
    defaultTitle: string;
    defaultDescription: string;
  };
}
